import { Component } from '@angular/core';

@Component({
  selector: 'td-wb-empty-header',
  template: '<ng-content />',
  styleUrls: ['empty-header.component.scss']
})
export class EmptyHeaderComponent {
}
